var RouteObject = /** @class */ (function () {
    function RouteObject() {
        this.adminOnly = false;
    }
    return RouteObject;
}());
export { RouteObject };
export var RouteKey;
(function (RouteKey) {
    RouteKey["HOME"] = "HOME";
    RouteKey["REQUERIMENTO_LISTAR"] = "REQUERIMENTO_LISTAR";
    RouteKey["REQUERIMENTO_CADASTRO"] = "REQUERIMENTO_CADASTRO";
    RouteKey["REQUERIMENTO_VISUALIZAR"] = "REQUERIMENTO_VISUALIZAR";
    RouteKey["REQUERIMENTO_EDITAR"] = "REQUERIMENTO_EDITAR";
    RouteKey["REQUERIMENTO_EMITIR_TAXAS"] = "REQUERIMENTO_EMITIR_TAXAS";
    RouteKey["NOTIFICACOES_LISTAR"] = "NOTIFICACOES_LISTAR";
})(RouteKey || (RouteKey = {}));
export var Routes = {
    HOME: { path: '/home', headerName: 'INTERMAT' },
    REQUERIMENTO_LISTAR: { path: '/requerimento/listar', headerName: 'Requerimento de Título' },
    REQUERIMENTO_CADASTRO: { path: '/requerimento/cadastro', headerName: 'Cadastro de Requerimento de Título' },
    REQUERIMENTO_VISUALIZAR: { path: '/requerimento/vizualizar', headerName: 'Visualização de Requerimento de Título' },
    REQUERIMENTO_EDITAR: { path: '/requerimento/editar', headerName: 'Requerimento de Título' },
    REQUERIMENTO_EMITIR_TAXAS: { path: '/requerimento/taxas', headerName: 'Emitir taxas' },
    NOTIFICACOES_LISTAR: { path: '/notificacoes', headerName: 'Notificações' },
};
